import React from 'react';

// Renders the stored style object as nested Rails form inputs. Keys with a null
// value are omitted entirely, so the schema's "nullable/absent" rules hold (an
// omitted eye_color means "inherit foreground"; an omitted gradient means none).
export default function styleHiddenInputs(style) {
  const inputs = [];
  const base = 'qr_code_template[style]';

  Object.entries(style).forEach(([key, value]) => {
    if (value == null) return;
    if (key === 'gradient') {
      inputs.push(<input key="grad-type" type="hidden" name={`${base}[gradient][type]`} value={value.type} readOnly />);
      value.stops.forEach((stop, i) => {
        inputs.push(<input key={`grad-stop-${i}`} type="hidden" name={`${base}[gradient][stops][]`} value={stop} readOnly />);
      });
      if (value.rotation != null) {
        inputs.push(<input key="grad-rot" type="hidden" name={`${base}[gradient][rotation]`} value={value.rotation} readOnly />);
      }
      return;
    }
    const serialized = typeof value === 'boolean' ? String(Number(value)) : value;
    inputs.push(<input key={key} type="hidden" name={`${base}[${key}]`} value={serialized} readOnly />);
  });

  return inputs;
}
